/**
 * 임의 형태 임금대장 → 카이온 마이그레이션 양식 치환 (프론트 테스트용, DB 미저장)
 * 대상 컬럼은 nodejs_caion/constants/wageMigrationColumns.js 와 동일 헤더를 사용한다.
 */

export type WageConvertType = 'home' | 'facility';

export interface WageConvertColumn {
  header: string;
  key: string;
  type: 'string' | 'number' | 'birth' | 'yn';
  required?: boolean;
}

/** 방문요양 카이온 임금대장 헤더 */
export const HOME_CONVERT_COLUMNS: WageConvertColumn[] = [
  { header: '성명', key: 'name', type: 'string', required: true },
  { header: '생년월일', key: 'birth', type: 'birth' },
  { header: '직종', key: 'job', type: 'string' },
  { header: '지급계산시급', key: 'payCalcHourly', type: 'number' },
  { header: '기본급', key: 'basic', type: 'number' },
  { header: '주휴수당', key: 'weekend', type: 'number' },
  { header: '연차수당', key: 'annual', type: 'number' },
  { header: '노동절수당', key: 'laborDay', type: 'number' },
  { header: '연장수당', key: 'overtime', type: 'number' },
  { header: '야간수당', key: 'night', type: 'number' },
  { header: '휴일수당', key: 'holiday', type: 'number' },
  { header: '장기근속수당', key: 'senior', type: 'number' },
  { header: '보수교육비', key: 'bosu', type: 'number' },
  { header: '중증수급자가산', key: 'severe', type: 'number' },
  { header: '중식비', key: 'lunch', type: 'number' },
  { header: '중식비(센터장)', key: 'lunchDirector', type: 'number' },
  { header: '상여금', key: 'bonus', type: 'number' },
  { header: '차량보조비', key: 'car', type: 'number' },
  { header: '양육비', key: 'child', type: 'number' },
  { header: '처우개선비', key: 'welfare', type: 'number' },
  { header: '기타수당', key: 'other', type: 'number' },
  { header: '연장시간', key: 'overtimeHours', type: 'number' },
  { header: '야간시간', key: 'nightHours', type: 'number' },
  { header: '휴일시간', key: 'holidayHours', type: 'number' },
  { header: '과세합계', key: 'wageTotal', type: 'number' },
  { header: '비과세', key: 'nonTax', type: 'number' },
  { header: '실수령액', key: 'net', type: 'number' },
  { header: '국민연금(근로)', key: 'l_yeon', type: 'number' },
  { header: '건강보험(근로)', key: 'l_gun', type: 'number' },
  { header: '장기요양(근로)', key: 'l_jang', type: 'number' },
  { header: '고용보험(근로)', key: 'l_go', type: 'number' },
  { header: '소득세', key: 'l_so', type: 'number' },
  { header: '지방세', key: 'l_ji', type: 'number' },
  { header: '지원공제', key: 'l_jiwon', type: 'number' },
  { header: '본인부담금공제', key: 'l_bonin', type: 'number' },
  { header: '기타공제', key: 'l_etc', type: 'number' },
  { header: '근로자공제합계', key: 'l_total', type: 'number' },
  { header: '국민연금(기관)', key: 'c_yeon', type: 'number' },
  { header: '건강보험(기관)', key: 'c_gun', type: 'number' },
  { header: '장기요양(기관)', key: 'c_jang', type: 'number' },
  { header: '고용보험(기관)', key: 'c_go', type: 'number' },
  { header: '실업급여', key: 'c_sil', type: 'number' },
  { header: '산재보험', key: 'c_san', type: 'number' },
  { header: '퇴직금', key: 'c_out', type: 'number' },
  { header: '기관공제합계', key: 'c_total', type: 'number' },
  { header: '대표자(Y/N)', key: 'isRepresentative', type: 'yn' },
  { header: '중식비 실비변상(Y/N)', key: 'lunchExpense', type: 'yn' },
];

/** 요양시설 카이온 임금대장 헤더 */
export const FACILITY_CONVERT_COLUMNS: WageConvertColumn[] = [
  { header: '성명', key: 'cwhd_name', type: 'string', required: true },
  { header: '생년월일', key: 'cwhd_birth', type: 'birth' },
  { header: '직종', key: 'ce_position', type: 'string' },
  { header: '시급', key: 'cwhd_pay_calc_hourly', type: 'number' },
  { header: '근무일수', key: 'cwhd_work_days', type: 'number' },
  { header: '근무시간', key: 'cwhd_work_hours', type: 'number' },
  { header: '기본급', key: 'cwhd_basic', type: 'number' },
  { header: '연장시간', key: 'cwhd_overtime_hours', type: 'number' },
  { header: '연장수당', key: 'cwhd_overtime', type: 'number' },
  { header: '야간시간', key: 'cwhd_night_hours', type: 'number' },
  { header: '야간수당', key: 'cwhd_night', type: 'number' },
  { header: '휴일시간', key: 'cwhd_holiday_hours', type: 'number' },
  { header: '휴일수당', key: 'cwhd_holiday', type: 'number' },
  { header: '주휴수당', key: 'cwhd_dayoff', type: 'number' },
  { header: '장기근속수당', key: 'cwhd_senior', type: 'number' },
  { header: '수임비', key: 'cwhd_sunim', type: 'number' },
  { header: '상여금', key: 'cwhd_bonus', type: 'number' },
  { header: '보수교육비', key: 'cwhd_bosu', type: 'number' },
  { header: '보전수당', key: 'cwhd_bojon', type: 'number' },
  { header: '기타수당', key: 'cwhd_other', type: 'number' },
  { header: '당직수당', key: 'cwhd_dang', type: 'number' },
  { header: '중식비', key: 'cwhd_lunch', type: 'number' },
  { header: '차량보조비', key: 'cwhd_car', type: 'number' },
  { header: '양육비', key: 'cwhd_child', type: 'number' },
  { header: '과세합계', key: 'cwhd_wage_total', type: 'number' },
  { header: '과세임금', key: 'cwhd_taxable', type: 'number' },
  { header: '통상임금', key: 'cwhd_usual', type: 'number' },
  { header: '국민연금(근로)', key: 'cwhd_l_yeon', type: 'number' },
  { header: '건강보험(근로)', key: 'cwhd_l_gun', type: 'number' },
  { header: '장기요양(근로)', key: 'cwhd_l_jang', type: 'number' },
  { header: '고용보험(근로)', key: 'cwhd_l_go', type: 'number' },
  { header: '소득세', key: 'cwhd_l_so', type: 'number' },
  { header: '지방세', key: 'cwhd_l_ji', type: 'number' },
  { header: '지원공제', key: 'cwhd_l_jiwon', type: 'number' },
  { header: '중식비공제', key: 'cwhd_l_sik', type: 'number' },
  { header: '기타공제', key: 'cwhd_l_etc', type: 'number' },
  { header: '연말정산', key: 'cwhd_l_yearend', type: 'number' },
  { header: '근로자공제합계', key: 'cwhd_l_total', type: 'number' },
  { header: '국민연금(기관)', key: 'cwhd_c_yeon', type: 'number' },
  { header: '건강보험(기관)', key: 'cwhd_c_gun', type: 'number' },
  { header: '장기요양(기관)', key: 'cwhd_c_jang', type: 'number' },
  { header: '고용보험(기관)', key: 'cwhd_c_go', type: 'number' },
  { header: '실업급여', key: 'cwhd_c_sil', type: 'number' },
  { header: '산재보험', key: 'cwhd_c_san', type: 'number' },
  { header: '퇴직금', key: 'cwhd_c_out', type: 'number' },
  { header: '기관공제합계', key: 'cwhd_c_total', type: 'number' },
  { header: '대표자(Y/N)', key: 'cwhd_is_owner', type: 'yn' },
  { header: '중식비 실비변상(Y/N)', key: 'cwhd_lunch_expense', type: 'yn' },
];

/**
 * 필드 인식 규칙.
 * 타 프로그램 임금대장은 헤더가 여러 줄·병합·동일 항목명(국민연금이 근로/기관에 두 번)인 경우가 많다.
 * alias 포함 + 금지 토큰 + 근로/기관 쪽으로 점수를 내고, 헤더가 비면 셀 내용으로 보완한다.
 */
type FieldSide = 'emp' | 'org' | 'any';
type ValueKind = 'name' | 'birth' | 'job' | 'money' | 'hourly' | 'days' | 'hours' | 'yn' | 'text';

interface FieldRule {
  id: string;
  aliases: string[];
  side: FieldSide;
  forbid: string[];
  /** forbid 토큰이 있어도 여기 토큰이 있으면 유지 (연장수당 vs 연장시간) */
  allow: string[];
  kind: ValueKind;
}

const FIELD_RULES: FieldRule[] = [
  { id: 'name', kind: 'name', side: 'any', forbid: ['영문', '한자', '주민', '코드', '번호', '일자', '서명'], allow: [], aliases: ['성명', '이름', '사원명', '직원명', '근로자명', '종사자명', '사원성명', '직원성명', '한글성명', '성명한글'] },
  { id: 'birth', kind: 'birth', side: 'any', forbid: ['입사', '퇴사', '지급일', '소득', '주민세'], allow: [], aliases: ['생년월일', '생일', '출생년월일', '주민등록번호', '주민번호', '주민등록', '주민번호앞', '주민앞자리'] },
  { id: 'job', kind: 'job', side: 'any', forbid: ['수당', '코드', '번호'], allow: [], aliases: ['직종', '직책', '직위', '직무', '직급', '담당업무', '업무구분', '담당직종'] },
  { id: 'hourly', kind: 'hourly', side: 'any', forbid: ['임금', '합계'], allow: ['시급'], aliases: ['지급계산시급', '통상시급', '시간급', '지급시급', '시급액', '시급'] },
  { id: 'workDays', kind: 'days', side: 'any', forbid: ['시간', '수당', '임금'], allow: [], aliases: ['근무일수', '출근일수', '소정근로일수', '근로일수', '근무일', '출근일'] },
  { id: 'workHours', kind: 'hours', side: 'any', forbid: ['연장', '야간', '휴일', '수당', '시급'], allow: [], aliases: ['소정근로시간', '총근무시간', '월근무시간', '근무시수', '근로시간', '근무시간', '총근로시간'] },
  { id: 'basic', kind: 'money', side: 'any', forbid: ['합계', '총액', '시급', '통상', '연장', '야간', '휴일', '주휴', '수당'], allow: ['기본'], aliases: ['월기본급', '기본급여', '기본임금', '기본수당', '기본급', '본봉', '월급'] },
  { id: 'weekend', kind: 'money', side: 'any', forbid: ['시간', '일수', '주휴일'], allow: ['수당'], aliases: ['유급주휴수당', '주휴수당', '유급주휴', '주휴'] },
  { id: 'annual', kind: 'money', side: 'any', forbid: ['일수', '사용일', '잔여'], allow: ['수당'], aliases: ['연차미사용수당', '연차수당', '미사용연차', '연차수당액', '연차'] },
  { id: 'laborDay', kind: 'money', side: 'any', forbid: [], allow: [], aliases: ['근로자의날수당', '근로자의날', '노동절수당', '노동절'] },
  { id: 'overtime', kind: 'money', side: 'any', forbid: ['시간', '시수'], allow: ['수당', '금액', '급'], aliases: ['연장근로수당', '초과근무수당', '시간외수당', '시간외근로수당', '연장수당', '연장급', '연장근로', 'ot'] },
  { id: 'night', kind: 'money', side: 'any', forbid: ['시간', '시수'], allow: ['수당', '금액', '급'], aliases: ['야간근로수당', '야간근무수당', '야근수당', '야간수당', '야간근로', '야간급'] },
  { id: 'holiday', kind: 'money', side: 'any', forbid: ['시간', '시수'], allow: ['수당', '금액', '급'], aliases: ['휴일근로수당', '휴일근무수당', '휴일수당', '휴일근로', '휴일급'] },
  { id: 'overtimeHours', kind: 'hours', side: 'any', forbid: ['수당', '금액'], allow: ['시간', '시수'], aliases: ['연장근로시간', '연장근무시간', '시간외시간', '시간외근로시간', '연장시간', '연장시수'] },
  { id: 'nightHours', kind: 'hours', side: 'any', forbid: ['수당', '금액'], allow: ['시간', '시수'], aliases: ['야간근로시간', '야간근무시간', '야근시간', '야간시간', '야간시수'] },
  { id: 'holidayHours', kind: 'hours', side: 'any', forbid: ['수당', '금액'], allow: ['시간', '시수'], aliases: ['휴일근로시간', '휴일근무시간', '휴일시간', '휴일시수'] },
  { id: 'senior', kind: 'money', side: 'any', forbid: ['퇴직'], allow: [], aliases: ['장기근속수당', '장기근속', '근속수당', '근속가산', '근속가산금'] },
  { id: 'bosu', kind: 'money', side: 'any', forbid: [], allow: [], aliases: ['보수교육비', '보수교육수당', '보수교육'] },
  { id: 'severe', kind: 'money', side: 'any', forbid: [], allow: [], aliases: ['중증수급자가산', '중증수급자', '중증가산', '중증수당', '중증가산'] },
  { id: 'lunch', kind: 'money', side: 'any', forbid: ['공제', '실비', '센터장'], allow: [], aliases: ['중식비', '중식대', '식사비', '식대', '식비', '중식'] },
  { id: 'lunchDirector', kind: 'money', side: 'any', forbid: ['공제', '실비'], allow: [], aliases: ['중식비센터장', '중식대센터장', '식대센터장', '센터장중식비', '센터장식대'] },
  { id: 'lunchExpense', kind: 'yn', side: 'any', forbid: [], allow: [], aliases: ['중식비실비변상', '식대실비변상', '중식실비변상', '실비변상'] },
  { id: 'lunchDeduct', kind: 'money', side: 'any', forbid: [], allow: [], aliases: ['중식비공제', '식대공제', '식비공제', '중식공제', '식대차감'] },
  { id: 'bonus', kind: 'money', side: 'any', forbid: ['세금', '공제'], allow: [], aliases: ['상여수당', '상여금', '성과급', '상여'] },
  { id: 'car', kind: 'money', side: 'any', forbid: ['공제'], allow: [], aliases: ['차량보조비', '차량유지비', '차량수당', '차량보조', '자가운전보조금', '교통비', '차량비'] },
  { id: 'child', kind: 'money', side: 'any', forbid: ['공제'], allow: [], aliases: ['자녀교육비', '양육수당', '자녀수당', '보육수당', '양육비'] },
  { id: 'welfare', kind: 'money', side: 'any', forbid: [], allow: [], aliases: ['처우개선비', '처우개선금', '처우개선'] },
  { id: 'sunim', kind: 'money', side: 'any', forbid: [], allow: [], aliases: ['위탁수임비', '수임비', '수임료', '수임'] },
  { id: 'bojon', kind: 'money', side: 'any', forbid: [], allow: [], aliases: ['임금보전수당', '보전수당', '임금보전', '보전'] },
  { id: 'dang', kind: 'money', side: 'any', forbid: ['시간'], allow: ['수당', '비'], aliases: ['당직수당', '당직비', '숙직수당', '당직'] },
  { id: 'other', kind: 'money', side: 'any', forbid: ['공제', '세금'], allow: [], aliases: ['기타수당', '기타급여', '기타지급', '기타지급액', '잡급'] },
  { id: 'wageTotal', kind: 'money', side: 'any', forbid: ['차인', '실수령', '실지급', '비과세', '공제'], allow: [], aliases: ['지급총액', '총지급액', '급여총액', '지급합계', '급여합계', '지급액계', '급여총계', '과세합계', '총급여', '지급총계', '총지급'] },
  { id: 'taxable', kind: 'money', side: 'any', forbid: ['비과세', '합계'], allow: [], aliases: ['과세표준', '과세대상', '과세급여', '과세임금', '과세총액', '과세액'] },
  { id: 'usual', kind: 'money', side: 'any', forbid: ['시급'], allow: ['임금'], aliases: ['통상임금액', '통상임금', '통상급여'] },
  { id: 'nonTax', kind: 'money', side: 'any', forbid: [], allow: [], aliases: ['비과세합계', '비과세총액', '비과세금액', '비과세액', '비과세'] },
  { id: 'net', kind: 'money', side: 'any', forbid: ['공제합계', '지급총액', '총지급'], allow: [], aliases: ['차인지급액', '차인지급', '차감지급액', '실지급액', '실수령액', '실수령', '실지급', '차인액', '수령액'] },
  { id: 'l_yeon', kind: 'money', side: 'emp', forbid: [], allow: [], aliases: ['국민연금보험료', '국민연금료', '국민연금'] },
  { id: 'l_gun', kind: 'money', side: 'emp', forbid: ['장기'], allow: [], aliases: ['건강보험료', '건강보험', '의료보험', '건보'] },
  { id: 'l_jang', kind: 'money', side: 'emp', forbid: ['기관명', '시설명'], allow: [], aliases: ['장기요양보험료', '노인장기요양보험', '장기요양보험', '노인장기요양', '장기요양', '요양보험'] },
  { id: 'l_go', kind: 'money', side: 'emp', forbid: ['실업', '산재'], allow: [], aliases: ['고용보험료', '고용보험'] },
  { id: 'l_so', kind: 'money', side: 'any', forbid: ['지방', '주민'], allow: [], aliases: ['근로소득세', '갑근세', '소득세'] },
  { id: 'l_ji', kind: 'money', side: 'any', forbid: [], allow: [], aliases: ['지방소득세', '지방소득세액', '주민세', '지방세'] },
  { id: 'l_jiwon', kind: 'money', side: 'any', forbid: [], allow: [], aliases: ['지원금공제', '지원공제', '공제지원', '급여지원공제'] },
  { id: 'l_bonin', kind: 'money', side: 'any', forbid: ['보험', '연금'], allow: [], aliases: ['본인부담금공제', '본인부담공제', '본인부담금'] },
  { id: 'l_etc', kind: 'money', side: 'any', forbid: ['수당', '급여'], allow: [], aliases: ['기타공제액', '기타공제', '공제기타', '기타차감'] },
  { id: 'l_yearend', kind: 'money', side: 'any', forbid: [], allow: [], aliases: ['연말정산환급', '연말정산세액', '연말정산소득세', '연말정산'] },
  { id: 'l_total', kind: 'money', side: 'emp', forbid: ['지급'], allow: [], aliases: ['근로자공제합계', '본인공제합계', '공제총액', '공제합계', '공제계', '공제합'] },
  { id: 'c_yeon', kind: 'money', side: 'org', forbid: [], allow: [], aliases: ['국민연금보험료', '국민연금료', '국민연금'] },
  { id: 'c_gun', kind: 'money', side: 'org', forbid: ['장기'], allow: [], aliases: ['건강보험료', '건강보험', '의료보험', '건보'] },
  { id: 'c_jang', kind: 'money', side: 'org', forbid: ['기관명', '시설명'], allow: [], aliases: ['장기요양보험료', '장기요양보험', '노인장기요양', '장기요양', '요양보험'] },
  { id: 'c_go', kind: 'money', side: 'org', forbid: ['실업', '산재'], allow: [], aliases: ['고용보험료', '고용보험'] },
  { id: 'c_sil', kind: 'money', side: 'org', forbid: [], allow: [], aliases: ['실업급여보험료', '고용보험실업급여', '실업급여'] },
  { id: 'c_san', kind: 'money', side: 'any', forbid: ['요율'], allow: [], aliases: ['산재보험료', '산업재해보험', '산재보험', '산업재해', '산재'] },
  { id: 'c_out', kind: 'money', side: 'any', forbid: ['연금추정'], allow: [], aliases: ['퇴직충당금', '퇴직금충당', '퇴직급여충당금', '퇴직급여', '퇴직금'] },
  { id: 'c_total', kind: 'money', side: 'org', forbid: ['지급'], allow: [], aliases: ['기관공제합계', '기관부담합계', '사업주부담합계', '사업주공제합계', '회사부담합계', '사용자부담합계', '공제합계', '부담금합계'] },
  { id: 'owner', kind: 'yn', side: 'any', forbid: ['번호', '전화', '연락', '성명'], allow: [], aliases: ['대표자여부', '대표여부', '원장여부', '대표자', '대표'] },
];

const KEY_TO_FIELD: Record<string, string> = {
  name: 'name',
  cwhd_name: 'name',
  birth: 'birth',
  cwhd_birth: 'birth',
  job: 'job',
  ce_position: 'job',
  payCalcHourly: 'hourly',
  cwhd_pay_calc_hourly: 'hourly',
  cwhd_work_days: 'workDays',
  cwhd_work_hours: 'workHours',
  basic: 'basic',
  cwhd_basic: 'basic',
  weekend: 'weekend',
  cwhd_dayoff: 'weekend',
  annual: 'annual',
  laborDay: 'laborDay',
  overtime: 'overtime',
  cwhd_overtime: 'overtime',
  night: 'night',
  cwhd_night: 'night',
  holiday: 'holiday',
  cwhd_holiday: 'holiday',
  overtimeHours: 'overtimeHours',
  cwhd_overtime_hours: 'overtimeHours',
  nightHours: 'nightHours',
  cwhd_night_hours: 'nightHours',
  holidayHours: 'holidayHours',
  cwhd_holiday_hours: 'holidayHours',
  senior: 'senior',
  cwhd_senior: 'senior',
  bosu: 'bosu',
  cwhd_bosu: 'bosu',
  severe: 'severe',
  lunch: 'lunch',
  cwhd_lunch: 'lunch',
  lunchDirector: 'lunchDirector',
  lunchExpense: 'lunchExpense',
  cwhd_lunch_expense: 'lunchExpense',
  cwhd_l_sik: 'lunchDeduct',
  bonus: 'bonus',
  cwhd_bonus: 'bonus',
  car: 'car',
  cwhd_car: 'car',
  child: 'child',
  cwhd_child: 'child',
  welfare: 'welfare',
  cwhd_sunim: 'sunim',
  cwhd_bojon: 'bojon',
  cwhd_dang: 'dang',
  other: 'other',
  cwhd_other: 'other',
  wageTotal: 'wageTotal',
  cwhd_wage_total: 'wageTotal',
  cwhd_taxable: 'taxable',
  cwhd_usual: 'usual',
  nonTax: 'nonTax',
  net: 'net',
  l_yeon: 'l_yeon',
  cwhd_l_yeon: 'l_yeon',
  l_gun: 'l_gun',
  cwhd_l_gun: 'l_gun',
  l_jang: 'l_jang',
  cwhd_l_jang: 'l_jang',
  l_go: 'l_go',
  cwhd_l_go: 'l_go',
  l_so: 'l_so',
  cwhd_l_so: 'l_so',
  l_ji: 'l_ji',
  cwhd_l_ji: 'l_ji',
  l_jiwon: 'l_jiwon',
  cwhd_l_jiwon: 'l_jiwon',
  l_bonin: 'l_bonin',
  l_etc: 'l_etc',
  cwhd_l_etc: 'l_etc',
  cwhd_l_yearend: 'l_yearend',
  l_total: 'l_total',
  cwhd_l_total: 'l_total',
  c_yeon: 'c_yeon',
  cwhd_c_yeon: 'c_yeon',
  c_gun: 'c_gun',
  cwhd_c_gun: 'c_gun',
  c_jang: 'c_jang',
  cwhd_c_jang: 'c_jang',
  c_go: 'c_go',
  cwhd_c_go: 'c_go',
  c_sil: 'c_sil',
  cwhd_c_sil: 'c_sil',
  c_san: 'c_san',
  cwhd_c_san: 'c_san',
  c_out: 'c_out',
  cwhd_c_out: 'c_out',
  c_total: 'c_total',
  cwhd_c_total: 'c_total',
  isRepresentative: 'owner',
  cwhd_is_owner: 'owner',
};

let fieldRules: FieldRule[] = FIELD_RULES;
let ruleById = new Map(fieldRules.map((rule) => [rule.id, rule]));

export interface WageColumnDictEntry {
  fieldKey: string;
  label: string;
  side: FieldSide | string;
  kind: ValueKind | string;
  forbid?: string[];
  allow?: string[];
  aliases?: string[];
}

const SIDES: FieldSide[] = ['emp', 'org', 'any'];
const KINDS: ValueKind[] = ['name', 'birth', 'job', 'money', 'hourly', 'days', 'hours', 'yn', 'text'];

/** DB 사전으로 매칭 규칙을 갈아끼운다. 비어 있으면 코드에 있는 기본 사전을 유지한다. */
export const applyWageColumnDictionary = (entries: WageColumnDictEntry[]) => {
  const next: FieldRule[] = [];
  for (const entry of entries || []) {
    const id = String(entry?.fieldKey || '').trim();
    if (!id) continue;
    const aliases = (entry.aliases || []).map((alias) => String(alias).trim()).filter(Boolean);
    const label = String(entry.label || '').trim();
    if (label && !aliases.includes(label)) aliases.unshift(label);
    if (!aliases.length) continue;
    const side = SIDES.includes(entry.side as FieldSide) ? (entry.side as FieldSide) : 'any';
    const kind = KINDS.includes(entry.kind as ValueKind) ? (entry.kind as ValueKind) : 'money';
    next.push({
      id,
      side,
      kind,
      forbid: (entry.forbid || []).map((item) => String(item).trim()).filter(Boolean),
      allow: (entry.allow || []).map((item) => String(item).trim()).filter(Boolean),
      aliases,
    });
  }
  if (!next.length) return;
  fieldRules = next;
  ruleById = new Map(fieldRules.map((rule) => [rule.id, rule]));
};

const ACCEPT_SCORE = 100;

export interface MergeRange {
  s: { r: number; c: number };
  e: { r: number; c: number };
}

export const normalizeHeader = (raw: unknown): string => {
  let s = String(raw ?? '').normalize('NFKC');
  s = s.replace(/[\u00a0\u200b\u3000]/g, '');
  s = s.replace(/[\r\n\t]+/g, '');
  s = s.replace(/\s+/g, '');
  s = s.replace(/[()（）[\]【】{}<>《》「」『』'"`“”‘’]/g, '');
  s = s.replace(/[._·・/\\|:：\-–—~*#※★☆@^]/g, '');
  s = s.replace(/yn$/i, '');
  return s.toLowerCase();
};

const detectSide = (header: string): 'emp' | 'org' | 'both' | 'any' => {
  const masked = header
    .replace(/연장근로/g, '')
    .replace(/야간근로/g, '')
    .replace(/휴일근로/g, '')
    .replace(/근로시간/g, '')
    .replace(/근로일/g, '')
    .replace(/근로소득/g, '소득');
  const emp = /근로자|근로부담|본인부담|본인|직원부담|가입자|피보험자|근로/.test(masked);
  const org = /사업주|사용자부담|기관부담|회사부담|사업장부담|법인부담|기관/.test(masked);
  if (emp && org) return 'both';
  if (emp) return 'emp';
  if (org) return 'org';
  return 'any';
};

const isForbidden = (header: string, rule: FieldRule): boolean => {
  for (const word of rule.forbid) {
    const token = normalizeHeader(word);
    if (!token || !header.includes(token)) continue;
    const allowed = rule.allow.some((item) => header.includes(normalizeHeader(item)));
    if (!allowed) return true;
  }
  return false;
};

/** 헤더 하나 ↔ 필드 규칙 점수. 0이면 후보 아님 */
const scoreHeaderAgainstRule = (rawHeader: unknown, rule: FieldRule): number => {
  const header = normalizeHeader(rawHeader);
  if (!header || isForbidden(header, rule)) return 0;

  const side = detectSide(header);
  if (rule.side === 'emp' && side === 'org') return 0;
  if (rule.side === 'org' && side === 'emp') return 0;

  let best = 0;
  for (const aliasRaw of rule.aliases) {
    const alias = normalizeHeader(aliasRaw);
    if (!alias) continue;
    const asciiShort = /^[a-z0-9]{1,2}$/.test(alias);
    if (header === alias) best = Math.max(best, 300 + alias.length * 10);
    else if (!asciiShort && alias.length >= 2 && header.includes(alias)) best = Math.max(best, 100 + alias.length * 10);
  }
  if (!best) return 0;

  if (rule.side === 'emp' && side === 'emp') best += 40;
  if (rule.side === 'org' && side === 'org') best += 40;
  return best;
};

const cellBestScore = (raw: unknown): number => {
  let best = 0;
  for (const rule of fieldRules) {
    best = Math.max(best, scoreHeaderAgainstRule(raw, rule));
  }
  return best;
};

const rowHeaderScore = (row: unknown[]): number => {
  let score = 0;
  for (const cell of row || []) {
    const header = normalizeHeader(cell);
    if (!header) continue;
    if (cellBestScore(cell) >= ACCEPT_SCORE) score += 2;
    else if (/지급내역|공제내역|인적사항|급여항목|공제항목|근로자부담|사업주부담|4대보험|보험료/.test(header)) {
      score += 1;
    }
  }
  return score;
};

const looksLikeData = (row: unknown[]): boolean => {
  let nums = 0;
  let texts = 0;
  for (const cell of row || []) {
    if (cell == null || String(cell).trim() === '') continue;
    if (typeof cell === 'number') {
      nums += 1;
      continue;
    }
    if (cell instanceof Date) {
      texts += 1;
      continue;
    }
    const text = String(cell).trim();
    if (/[가-힣]{2,}/.test(text) && !/\d{3,}/.test(text)) texts += 1;
    else if (!Number.isNaN(parseNum(text)) && /\d/.test(text)) nums += 1;
    else texts += 1;
  }
  return nums >= 3 && nums > texts;
};

const isUnitRow = (row: unknown[]): boolean => {
  const cells = (row || []).map((cell) => normalizeHeader(cell)).filter(Boolean);
  if (cells.length < 2) return false;
  const units = cells.filter((cell) => /^(원|시간|일|명|세|%|단위원)$/.test(cell)).length;
  return units >= Math.max(2, Math.ceil(cells.length * 0.6));
};

const isSectionRow = (row: unknown[]): boolean => {
  const cells = (row || []).map((cell) => normalizeHeader(cell)).filter(Boolean);
  if (!cells.length || looksLikeData(row)) return false;
  const section = cells.filter((cell) =>
    /지급|공제|부담|인적|급여항목|공제항목|4대보험|보험료|근로자|사업주|기관|회사/.test(cell)
  ).length;
  return section >= 1 && section >= cells.length * 0.4;
};

const shouldForwardFill = (row: unknown[]): boolean => {
  let filled = 0;
  let empty = 0;
  for (const cell of row || []) {
    if (String(cell ?? '').trim()) filled += 1;
    else empty += 1;
  }
  return filled > 0 && empty >= filled;
};

export const parseNum = (val: unknown): number => {
  if (val == null || val === '') return 0;
  if (typeof val === 'number' && Number.isFinite(val)) return val;
  const text = String(val).trim();
  if (!text || /^[-–—]$/.test(text)) return 0;
  const negative = /^\(.*\)$/.test(text);
  const n = Number(text.replace(/[(),원\s]/g, '').replace(/,/g, ''));
  if (!Number.isFinite(n)) return NaN;
  return negative ? -n : n;
};

const centuryFromGender = (gender: string, yy: number): number => {
  if ('3478'.includes(gender)) return 2000;
  if ('1256'.includes(gender)) return 1900;
  if ('90'.includes(gender)) return 1800;
  return yy > 30 ? 1900 : 2000;
};

export const parseBirth = (val: unknown): string => {
  if (val == null || val === '') return '';
  if (val instanceof Date && !Number.isNaN(val.getTime())) {
    const y = val.getFullYear();
    const m = String(val.getMonth() + 1).padStart(2, '0');
    const d = String(val.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }
  if (typeof val === 'number' && Number.isFinite(val)) {
    const digits = String(Math.trunc(Math.abs(val)));
    if (/^\d{8}$/.test(digits)) {
      return `${digits.slice(0, 4)}-${digits.slice(4, 6)}-${digits.slice(6, 8)}`;
    }
  }
  const text = String(val).trim();
  const iso = text.match(/^(\d{4})[-./](\d{1,2})[-./](\d{1,2})/);
  if (iso) {
    return `${iso[1]}-${iso[2].padStart(2, '0')}-${iso[3].padStart(2, '0')}`;
  }
  const digits = text.replace(/[^\d]/g, '');
  const rrnLike = digits.length === 13 || (digits.length >= 7 && digits.length <= 13 && text.includes('-'));
  if (rrnLike || /^\d{6}$/.test(digits)) {
    const yy = Number(digits.slice(0, 2));
    const mm = Number(digits.slice(2, 4));
    const dd = Number(digits.slice(4, 6));
    if (mm >= 1 && mm <= 12 && dd >= 1 && dd <= 31) {
      const gender = digits.length >= 7 ? digits[6] : '';
      const year = centuryFromGender(gender, yy) + yy;
      if (year >= 1930 && year <= 2015) {
        return `${year}-${String(mm).padStart(2, '0')}-${String(dd).padStart(2, '0')}`;
      }
    }
  }
  const compact = text.match(/^(\d{4})(\d{2})(\d{2})/);
  if (compact) return `${compact[1]}-${compact[2]}-${compact[3]}`;
  return text.substring(0, 10);
};

export const parseYn = (val: unknown): string => {
  const text = String(val ?? '').trim().toUpperCase();
  if (!text) return 'N';
  if (['Y', 'YES', '예', '1', 'TRUE', 'O', '○', '대표', '여'].includes(text)) return 'Y';
  if (['N', 'NO', '아니오', '0', 'FALSE', 'X', '×', '부'].includes(text)) return 'N';
  return 'N';
};

const JOB_RE = /요양|복지|간호|조리|사무|시설장|물리|작업치료|영양|운전|위생|센터장|요보|관리자|생활지도|야간보호|주간보호/;

const isPersonName = (raw: unknown): boolean => {
  const text = String(raw ?? '').trim().replace(/\s/g, '');
  if (!/^[가-힣]{2,4}$/.test(text)) return false;
  if (JOB_RE.test(text)) return false;
  if (/수당|보험|연금|공제|급여|합계|대장|센터|원장/.test(text)) return false;
  return true;
};

const isJobText = (raw: unknown): boolean => JOB_RE.test(String(raw ?? '').replace(/\s/g, ''));

const SKIP_NAME = /^(합계|소계|총계|총합계|누계|총합|합계금액|인원계|소계금액|계|총원|평균|비고)$/;
const HEADER_NAME = /^(성명|이름|사원명|직원명|근로자명|종사자명|사원성명)$/;

export interface SourceColumnOption {
  index: number;
  label: string;
}

export type ColumnMapping = Record<string, number | null>;

export interface HeaderAnalysis {
  headerRowIndex: number;
  dataStartIndex: number;
  labels: string[];
  notes: string[];
}

const gridWidth = (rows: unknown[][], until = 40): number => {
  let width = 0;
  const limit = Math.min(rows.length, until);
  for (let i = 0; i < limit; i++) width = Math.max(width, rows[i]?.length || 0);
  return width;
};

/** 병합 셀은 왼쪽·위 값만 남으므로, 범위 안 빈칸을 그 값으로 채운다 */
export const expandMergedCells = (rows: unknown[][], merges: MergeRange[] = []): unknown[][] => {
  const grid = rows.map((row) => (Array.isArray(row) ? row.slice() : []));
  for (const merge of merges || []) {
    const sr = merge?.s?.r ?? 0;
    const sc = merge?.s?.c ?? 0;
    const er = merge?.e?.r ?? sr;
    const ec = merge?.e?.c ?? sc;
    while (grid.length <= er) grid.push([]);
    const value = grid[sr]?.[sc];
    if (value == null || String(value).trim() === '') continue;
    for (let r = sr; r <= er; r++) {
      if (!grid[r]) grid[r] = [];
      for (let c = sc; c <= ec; c++) {
        if (r === sr && c === sc) continue;
        const current = grid[r][c];
        if (current == null || String(current).trim() === '') grid[r][c] = value;
      }
    }
  }
  return grid;
};

/**
 * 항목이 세로로 쌓인 대장(왼쪽이 성명·기본급·국민연금)을 가로 임금대장으로 돌린다.
 */
export const pivotVerticalLedger = (
  rows: unknown[][]
): { rows: unknown[][]; pivoted: boolean } => {
  if (rows.length < 4) return { rows, pivoted: false };
  const scan = Math.min(rows.length, 30);
  let bestRow = 0;
  for (let i = 0; i < scan; i++) bestRow = Math.max(bestRow, rowHeaderScore(rows[i] || []));

  let bestCol = 0;
  let bestColIdx = 0;
  const probe = Math.min(6, gridWidth(rows, scan));
  for (let c = 0; c < probe; c++) {
    const score = rowHeaderScore(rows.map((row) => row?.[c]));
    if (score > bestCol) {
      bestCol = score;
      bestColIdx = c;
    }
  }
  if (bestCol < 8 || bestCol < bestRow + 4) return { rows, pivoted: false };

  const width = gridWidth(rows, rows.length);
  const header = rows.map((row) => row?.[bestColIdx] ?? '');
  const data: unknown[][] = [];
  for (let c = 0; c < width; c++) {
    if (c === bestColIdx) continue;
    const line = rows.map((row) => row?.[c] ?? '');
    if (line.every((cell) => String(cell ?? '').trim() === '')) continue;
    data.push(line);
  }
  if (!data.length) return { rows, pivoted: false };
  return { rows: [header, ...data], pivoted: true };
};

const findHeaderBand = (
  rows: unknown[][],
  anchor: number | null
): { top: number; bottom: number } => {
  const limit = Math.min(rows.length, 40);
  let leaf = 0;
  if (anchor != null && anchor >= 0 && anchor < rows.length) {
    leaf = anchor;
  } else {
    let best = -1;
    for (let i = 0; i < limit; i++) {
      const score = rowHeaderScore(rows[i] || []);
      if (score > best) {
        best = score;
        leaf = i;
      }
    }
  }

  let top = leaf;
  while (top > 0 && leaf - top < 3) {
    const prev = rows[top - 1] || [];
    if (looksLikeData(prev)) break;
    if (rowHeaderScore(prev) >= 1 || isSectionRow(prev)) top -= 1;
    else break;
  }

  let bottom = leaf;
  while (bottom + 1 < rows.length && bottom - top < 4) {
    const next = rows[bottom + 1] || [];
    if (looksLikeData(next) || isUnitRow(next)) break;
    if (rowHeaderScore(next) >= 1 || isSectionRow(next)) bottom += 1;
    else break;
  }
  return { top, bottom };
};

/** 여러 줄 헤더를 열마다 "상위 / 하위" 한 줄로 합친다 */
export const analyzeHeaders = (
  rows: unknown[][],
  anchor: number | null = null
): HeaderAnalysis => {
  const notes: string[] = [];
  if (!rows.length) {
    return { headerRowIndex: 0, dataStartIndex: 0, labels: [], notes };
  }
  const { top, bottom } = findHeaderBand(rows, anchor);
  const width = Math.max(gridWidth(rows, Math.max(bottom + 12, 20)), ...(rows.slice(top, bottom + 1).map((row) => row?.length || 0)));
  const band = rows.slice(top, bottom + 1).map((row) => {
    const copy = (row || []).slice(0, width);
    while (copy.length < width) copy.push('');
    return copy;
  });

  for (let r = 0; r < band.length - 1; r++) {
    if (!shouldForwardFill(band[r])) continue;
    let last = '';
    for (let c = 0; c < width; c++) {
      const current = String(band[r][c] ?? '').trim();
      if (current) {
        const recognized = cellBestScore(current) >= ACCEPT_SCORE;
        const group = /지급|공제|부담|인적|급여|보험|수당|과세|비과세|근로자|사업주|기관|회사/.test(normalizeHeader(current));
        last = !recognized && group ? current : '';
      } else if (last) {
        band[r][c] = last;
      }
    }
  }

  const labels: string[] = [];
  for (let c = 0; c < width; c++) {
    const parts: string[] = [];
    for (let r = 0; r < band.length; r++) {
      const text = String(band[r][c] ?? '').replace(/[\r\n]+/g, ' ').replace(/\s+/g, ' ').trim();
      if (!text) continue;
      if (parts[parts.length - 1] === text) continue;
      parts.push(text);
    }
    labels.push(parts.join(' / '));
  }

  let dataStart = bottom + 1;
  if (isUnitRow(rows[dataStart] || [])) {
    notes.push('단위 행(원·시간)은 데이터에서 뺐습니다.');
    dataStart += 1;
  }
  while (dataStart < rows.length && (rows[dataStart] || []).every((cell) => String(cell ?? '').trim() === '')) {
    dataStart += 1;
  }

  if (bottom > top) {
    notes.push(`${top + 1}~${bottom + 1}행 헤더를 한 줄로 합쳤습니다.`);
  }
  return { headerRowIndex: top, dataStartIndex: dataStart, labels, notes };
};

const columnSamples = (dataRows: unknown[][], index: number, limit = 40): unknown[] => {
  const values: unknown[] = [];
  for (const row of dataRows) {
    if (values.length >= limit) break;
    const cell = row?.[index];
    if (cell == null || String(cell).trim() === '') continue;
    const name = normalizeHeader(row?.[0]);
    if (SKIP_NAME.test(name)) continue;
    values.push(cell);
  }
  return values;
};

const ratio = (values: unknown[], test: (value: unknown) => boolean): number => {
  if (!values.length) return 0;
  return values.filter(test).length / values.length;
};

interface ContentProfile {
  index: number;
  name: number;
  birth: number;
  job: number;
  hourly: number;
  days: number;
  hours: number;
}

const profileColumn = (dataRows: unknown[][], index: number): ContentProfile => {
  const values = columnSamples(dataRows, index);
  const numbers = values
    .map((value) => parseNum(value))
    .filter((value) => Number.isFinite(value) && value !== 0);
  const ints = numbers.filter((value) => Number.isInteger(value));
  const max = numbers.length ? Math.max(...numbers) : 0;
  const sorted = numbers.slice().sort((a, b) => a - b);
  const median = sorted.length ? sorted[Math.floor(sorted.length / 2)] : 0;
  const hourlyHit = numbers.filter((value) => value >= 5000 && value <= 60000).length;
  const dayHit = ints.filter((value) => value >= 0 && value <= 31).length;
  const hourHit = numbers.filter((value) => value > 0 && value <= 400).length;
  return {
    index,
    name: ratio(values, isPersonName),
    birth: ratio(values, (value) => {
      const parsed = parseBirth(value);
      return /^\d{4}-\d{2}-\d{2}$/.test(parsed) && Number(parsed.slice(0, 4)) <= 2015;
    }),
    job: ratio(values, isJobText),
    hourly: numbers.length >= 2 && max < 200000 ? hourlyHit / numbers.length : 0,
    days: ints.length >= 2 && max <= 31 ? dayHit / Math.max(ints.length, 1) : 0,
    hours: numbers.length >= 2 && max <= 450 && median <= 320 && median > 0 ? hourHit / numbers.length : 0,
  };
};

const applyContentHints = (
  mapping: ColumnMapping,
  columns: WageConvertColumn[],
  dataRows: unknown[][],
  labels: string[],
  notes: string[]
): void => {
  if (!dataRows.length) return;
  const width = Math.max(labels.length, gridWidth(dataRows, 25));
  const profiles: ContentProfile[] = [];
  for (let i = 0; i < width; i++) profiles.push(profileColumn(dataRows, i));

  const used = new Set<number>();
  for (const col of columns) {
    const idx = mapping[col.key];
    if (idx != null) used.add(idx);
  }

  type Pair = { key: string; index: number; score: number; label: string };
  const pairs: Pair[] = [];
  for (const col of columns) {
    if (mapping[col.key] != null) continue;
    const fieldId = KEY_TO_FIELD[col.key];
    const rule = fieldId ? ruleById.get(fieldId) : undefined;
    if (!rule) continue;
    for (const profile of profiles) {
      if (used.has(profile.index)) continue;
      let score = 0;
      if (rule.kind === 'name' && profile.name >= 0.55 && profile.job < 0.4) score = profile.name;
      else if (rule.kind === 'birth' && profile.birth >= 0.45 && profile.name < 0.3) score = profile.birth;
      else if (rule.kind === 'job' && profile.job >= 0.4 && profile.name < 0.5) score = profile.job;
      else if (rule.kind === 'hourly' && profile.hourly >= 0.7 && profile.hourly >= profile.days) score = profile.hourly;
      else if (rule.kind === 'days' && profile.days >= 0.7 && profile.days > profile.hours) score = profile.days;
      if (score > 0) pairs.push({ key: col.key, index: profile.index, score, label: col.header });
    }
  }

  pairs.sort((a, b) => b.score - a.score);
  const usedKeys = new Set<string>();
  const inferred: string[] = [];
  for (const pair of pairs) {
    if (usedKeys.has(pair.key) || used.has(pair.index)) continue;
    if (mapping[pair.key] != null) continue;
    mapping[pair.key] = pair.index;
    usedKeys.add(pair.key);
    used.add(pair.index);
    inferred.push(pair.label);
  }
  if (inferred.length) {
    notes.push(`헤더가 비거나 알아보기 어려운 열 ${inferred.length}개는 셀 내용으로 맞췄습니다 (${inferred.join(', ')}).`);
  }
};

/** 소스 헤더 → 카이온 컬럼. 점수 높은 쌍부터 1:1로 배정하고, 남은 식별 열은 내용으로 채운다 */
export const suggestColumnMapping = (
  sourceHeaders: unknown[],
  columns: WageConvertColumn[],
  dataRows: unknown[][] = [],
  notes?: string[]
): ColumnMapping => {
  type Cand = { key: string; srcIdx: number; score: number };
  const cands: Cand[] = [];
  const width = Math.max(sourceHeaders.length, gridWidth(dataRows, 20));

  for (const col of columns) {
    const fieldId = KEY_TO_FIELD[col.key];
    const rule = fieldId ? ruleById.get(fieldId) : undefined;
    if (!rule) continue;
    for (let i = 0; i < width; i++) {
      const score = scoreHeaderAgainstRule(sourceHeaders[i] ?? '', rule);
      if (score >= ACCEPT_SCORE) cands.push({ key: col.key, srcIdx: i, score });
    }
  }

  cands.sort((a, b) => b.score - a.score || a.srcIdx - b.srcIdx);
  const usedKeys = new Set<string>();
  const usedSrc = new Set<number>();
  const mapping: ColumnMapping = {};
  for (const col of columns) mapping[col.key] = null;

  for (const cand of cands) {
    if (usedKeys.has(cand.key) || usedSrc.has(cand.srcIdx)) continue;
    mapping[cand.key] = cand.srcIdx;
    usedKeys.add(cand.key);
    usedSrc.add(cand.srcIdx);
  }

  applyContentHints(mapping, columns, dataRows, sourceHeaders.map((header) => String(header ?? '')), notes || []);
  return mapping;
};

export const buildSourceColumnOptions = (headerRow: unknown[]): SourceColumnOption[] =>
  headerRow.map((header, index) => {
    const label = String(header ?? '').trim();
    return {
      index,
      label: label ? `${index + 1}. ${label}` : `${index + 1}. (빈 헤더)`,
    };
  });

export interface ConvertedRow {
  rowNum: number;
  values: Record<string, string | number>;
  name: string;
  warnings: string[];
  errors: string[];
}

export const convertRows = (
  dataRows: unknown[][],
  dataStartIndex: number,
  mapping: ColumnMapping,
  columns: WageConvertColumn[],
  options?: { excelSerialToDate?: (n: number) => string }
): ConvertedRow[] => {
  const nameKey = columns.find((col) => col.required)?.key || columns[0]?.key;
  const result: ConvertedRow[] = [];

  for (let i = 0; i < dataRows.length; i++) {
    const row = dataRows[i] || [];
    const values: Record<string, string | number> = {};
    const warnings: string[] = [];
    const errors: string[] = [];

    for (const col of columns) {
      const srcIdx = mapping[col.key];
      if (srcIdx == null || srcIdx < 0) {
        values[col.key] = col.type === 'number' ? 0 : col.type === 'yn' ? 'N' : '';
        continue;
      }
      const raw = row[srcIdx];

      if (col.type === 'number') {
        const n = parseNum(raw);
        if (Number.isNaN(n)) {
          errors.push(`'${col.header}' 숫자 아님`);
          values[col.key] = 0;
        } else {
          values[col.key] = n;
        }
      } else if (col.type === 'birth') {
        let birth = '';
        if (typeof raw === 'number' && options?.excelSerialToDate && raw > 20000 && raw < 60000) {
          const iso = options.excelSerialToDate(raw);
          const year = Number(String(iso).slice(0, 4));
          birth = year >= 1930 && year <= 2015 ? iso : parseBirth(raw);
        } else {
          birth = parseBirth(raw);
        }
        values[col.key] = birth;
      } else if (col.type === 'yn') {
        values[col.key] = parseYn(raw);
      } else {
        values[col.key] = String(raw ?? '').trim();
      }
    }

    const name = String(values[nameKey] ?? '').trim();
    const nameNorm = normalizeHeader(name);
    if (!nameNorm || SKIP_NAME.test(nameNorm) || HEADER_NAME.test(nameNorm)) continue;
    if (colMissingRequired(columns, values)) errors.push('필수 항목 누락');

    result.push({
      rowNum: dataStartIndex + i + 1,
      values,
      name,
      warnings,
      errors,
    });
  }
  return result;
};

const colMissingRequired = (
  columns: WageConvertColumn[],
  values: Record<string, string | number>
): boolean => {
  for (const col of columns) {
    if (!col.required) continue;
    if (!String(values[col.key] ?? '').trim()) return true;
  }
  return false;
};

export const mappingCoverage = (
  mapping: ColumnMapping,
  columns: WageConvertColumn[]
): { mapped: number; requiredOk: boolean; total: number } => {
  let mapped = 0;
  let requiredOk = true;
  for (const col of columns) {
    if (mapping[col.key] != null) mapped += 1;
    else if (col.required) requiredOk = false;
  }
  return { mapped, requiredOk, total: columns.length };
};

